<template>
  <div class="gs-media-ph" :style="boxStyle">
    <img class="gs-media-ph-icon" src="@/assets/images/share/aperture.png" alt="">
    <span>{{ label }}</span>
  </div>
</template>

<script>
export default {
  name: 'GsMediaPh',
  props: {
    label: {
      type: String,
      default: '暂无图片'
    },
    width: {
      type: [String, Number],
      default: 106
    },
    height: {
      type: [String, Number],
      default: 106
    }
  },
  computed: {
    boxStyle() {
      const w = typeof this.width === 'number' ? `${this.width}px` : this.width
      const h = typeof this.height === 'number' ? `${this.height}px` : this.height
      return { width: w, height: h }
    }
  }
}
</script>

<style scoped>
.gs-media-ph {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 10px;
  background:
    linear-gradient(180deg, #F4F8FF 0%, #E8F1FF 100%);
  border: 1px dashed #9EC0FF;
  color: #0165FF;
  flex-shrink: 0;
}
.gs-media-ph-icon {
  width: 36px;
  height: 36px;
  object-fit: contain;
  filter: brightness(0) saturate(100%) invert(27%) sepia(96%) saturate(2476%) hue-rotate(206deg) brightness(99%) contrast(103%);
}
.gs-media-ph span {
  font-size: 12px;
  line-height: 1;
  color: #5B7CB5;
}
</style>
